import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";


import authReducer from "../redux/slices/authSlice";
import categorySliceReducer from "../redux/slices/categorySlice";
import userSliceReducer from "../redux/slices/userSlice";
import blogSliceReducer from "../redux/slices/blogslice";
import siteDetailReducer from "../redux/slices/siteDetailSlice";
import contactReducer from "../redux/slices/contactSlice";
import vendorReducer from "../redux/slices/vendorSlice";
import reviewReducer from "../redux/slices/reviewSlice";
import notificationReducer from "../redux/slices/notificationSlice";
import adminMessageReducer from "../redux/slices/adminMessagesSlice";
import jobReducer from "../redux/slices/jobSlice";
import bookingReducer from "../redux/slices/bookingSlice";
import categoryReducer from "../redux/slices/categorySlice";
import productCategoryReducer from "../redux/slices/productCategorySlice";
import vehicleReducer from "../redux/slices/vehicleSlice";
import productReducer from "../redux/slices/productSlice";
import billReducer from "../redux/slices/billSlice";
import inventoryReducer from "../redux/slices/inventorySlice";
import businessProfileReducer from "../redux/slices/businessProfileSlice";
import blogCategoryReducer from "../redux/slices/blogCategorySlice"


// COMBINE ALL REDUCERS
const rootReducer = combineReducers({

  auth: authReducer,
  categories: categorySliceReducer,
  adminMessages: adminMessageReducer,
  users: userSliceReducer,
  blogs: blogSliceReducer,
  siteDetail: siteDetailReducer,
  contact: contactReducer,
  vendor: vendorReducer,
  reviews: reviewReducer,
  notifications: notificationReducer,
  jobs: jobReducer,
  booking: bookingReducer,
  category: categoryReducer,
  productCategory: productCategoryReducer,
  vehicle: vehicleReducer,
  product: productReducer,
  bill: billReducer,
  inventory: inventoryReducer,
  businessProfile: businessProfileReducer,
  blogCategory: blogCategoryReducer

});


// REDUX-PERSIST CONFIG
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // only auth persists
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// CONFIGURE STORE
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/PURGE',
          'persist/REGISTER',
        ],
        // Optionally ignore paths if you have non-serializable values
        ignoredPaths: ['auth.register'], // for example
      },
    }),
});

export const persistor = persistStore(store);

export default store;
